import { render } from "./CountryDetails.vue?vue&type=template&id=6b50b46d&scoped=true"
import script from "./CountryDetails.vue?vue&type=script&lang=js"
export * from "./CountryDetails.vue?vue&type=script&lang=js"

import "./CountryDetails.vue?vue&type=style&index=0&id=6b50b46d&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6b50b46d"

export default script